/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeSources200ResponseData
 */
export interface MergeSources200ResponseData {
    /**
     * The ID of the surviving source
     */
    source_to_keep_id: string;
}

/**
 * Check if a given object implements the MergeSources200ResponseData interface.
 */
export function instanceOfMergeSources200ResponseData(value: object): value is MergeSources200ResponseData {
    if (!('source_to_keep_id' in value) || value['source_to_keep_id'] === undefined) return false;
    return true;
}

export function MergeSources200ResponseDataFromJSON(json: any): MergeSources200ResponseData {
    return MergeSources200ResponseDataFromJSONTyped(json, false);
}

export function MergeSources200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSources200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'source_to_keep_id': json['source_to_keep_id'],
    };
}

export function MergeSources200ResponseDataToJSON(json: any): MergeSources200ResponseData {
    return MergeSources200ResponseDataToJSONTyped(json, false);
}

export function MergeSources200ResponseDataToJSONTyped(value?: MergeSources200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_to_keep_id': value['source_to_keep_id'],
    };
}

